import SentryWrap from "components/Sentry";
import React, { memo } from "react";

const FillingDisplay = ({
  text,
  highlights,
  is_correct,
  answer_text,
}) => {
  const generateBlanksText = (text, highlights) => {
    try {
      let result = [];
      let currentIndex = 0;

      const sortedHighlights = highlights
        ?.flat()
        ?.sort((a, b) => a.start - b.start);

      if (sortedHighlights) {
        sortedHighlights.forEach((highlight, index) => {
          if (highlight.start > currentIndex) {
            result.push(text.slice(currentIndex, highlight.start));
          }

          result.push(
            <span
              className={`fill-in-the-blanks-preview ${
                is_correct
                    ? "fill-blanks-green"
                    : "fill-blanks-red"
              }`}
            >
              {answer_text}
            </span>
          );

          currentIndex = highlight.end;
        });
      }

      if (currentIndex < text.length) {
        result.push(text.slice(currentIndex));
      }

      return result;
    } catch (error) {
      console.log(error);
    }
  };

  const processedText = generateBlanksText(text, highlights);
  return (
    <SentryWrap>
      <div
        className={`fill-in-the-blanks-assignment-review`}
        style={{ fontSize: "16px", lineHeight: "31px" }}
      >
       {processedText}
      </div>
    </SentryWrap>
  );
};

export default memo(FillingDisplay);
